import styled from '@emotion/styled';
import { Button, Input, Space, Table } from 'antd';
import { orderBy } from 'lodash';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { FaDownload } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { CompteEntity } from '../../../../entities/compte.entity';
import { ConnectedUserEntity } from '../../../../entities/ConnectedUserEntity';
import { PRIMARY, YELLOW } from '../../../../shared/colors';
import { formatNum } from '../../../../shared/constants';
import { Layout } from '../../../shared/Layout';
import { exportCompteData } from '../components/exportDataExcel';
import { getComptes } from '../network';

const Container = styled.div`
  height: calc(100vh - 30px);
  display: flex;
  background-color: #1c2025;
  color: white;

  .bread-crum span {
    color: white;
  }

  td.ant-table-column-sort {
    background-color: transparent !important;
  }

  th {
    background-color: ${PRIMARY} !important;
    color: white !important;
    font-weight: bold;
  }

  .odd-row {
    background-color: #757575;
    color: white;
  }

  .even-row {
    background-color: #acacac;
    color: white;
  }

  .odd-row,
  .even-row {
    &:hover > td {
      background-color: ${YELLOW} !important;
      cursor: pointer;
      color: black; /* plus lisible */
    }
  }

  .content {
    padding: 50px;
    width: 100%;
    background-color: #1c2025;
    color: white;
  }
`;

export const ComptePage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [comptes, setComptes] = useState<CompteEntity[]>([]);
  const [filterComptes, setFilterComptes] = useState<CompteEntity[]>([]);
  const connectedUser: ConnectedUserEntity = useSelector(
    (state: any) => state.userReducer,
  ).user;

  useEffect(() => {
    getComptes(connectedUser.id).then(({ data }) => {
      setComptes(orderBy(data, 'num_compte', 'asc'));
      setFilterComptes(orderBy(data, 'num_compte', 'asc'));
      setIsLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const search = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilterComptes(
      comptes.filter(
        (cpt) =>
          cpt.num_compte.toLowerCase().includes(e.target.value.toLowerCase()) ||
          cpt.intitule.toLowerCase().includes(e.target.value.toLowerCase()),
      ),
    );
  };

  return (
    <Layout>
      <Container>
        {/** Obtain 'current' values in Sidebar component */}
        <div className='content'>
          <h2 style={{ marginBottom: 0, color: 'white' }}>
            Comptabilite - Comptes
          </h2>
          <div style={{ marginTop: 5 }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: 5,
              }}
            >
              <Input
                placeholder='Search...'
                style={{ width: 250 }}
                onChange={search}
              />

              <Space>
                <Button
                  icon={
                    <FaDownload style={{ marginBottom: -2, marginRight: 5 }} />
                  }
                  className='butt'
                  style={{ borderRadius: 5 }}
                  onClick={() => exportCompteData(comptes)}
                >
                  Exporter
                </Button>
              </Space>
            </div>

            <Table
              columns={COLUMNS}
              dataSource={filterComptes}
              rowClassName={(row, index) =>
                index % 2 === 0 ? 'even-row' : 'odd-row'
              }
              size='small'
              loading={isLoading}
              style={{ zoom: 0.9 }}
              pagination={false}
            />
          </div>
        </div>
      </Container>
    </Layout>
  );
};

const COLUMNS = [
  {
    title: 'Chapitre',
    dataIndex: 'code_chapitre',
  },
  {
    title: 'Numéro de compte',
    dataIndex: 'num_compte',
  },
  {
    title: 'Intitulé compte',
    dataIndex: 'intitule',
  },
  {
    title: 'Crédit',
    dataIndex: 'credit',
    render: (cell: any) => `${formatNum(cell)}`,
  },
  {
    title: 'Débit',
    dataIndex: 'debit',
    render: (cell: any) => `${formatNum(cell)}`,
  },
  {
    title: 'Solde',
    dataIndex: 'solde',
    render: (cell: any) => `${formatNum(cell)}`,
  },
  {
    title: 'Dernier crédit',
    dataIndex: 'date_dernier_credit',
    render: (cell: any) =>
      cell ? `${moment(cell).format('DD/MM/YYYY')}` : '--',
  },
  {
    title: 'Dernier débit',
    dataIndex: 'date_dernier_debit',
    render: (cell: any) =>
      cell ? `${moment(cell).format('DD/MM/YYYY')}` : '--',
  },
  {
    title: 'Statut',
    dataIndex: 'statut',
    align: 'center' as const,
  },
  {
    title: 'Date création',
    dataIndex: 'created_at',
    render: (cell: any) => `${moment(cell).format('DD/MM/YYYY')}`,
  },
];
